<template>
  <div class="material-tags">
    <nuxt-link
      v-if="category.slug"
      :to="`/${category.slug}`"
      :class="['material-tags__category', getCategoryClass]"
    >
      {{ category.name }}
    </nuxt-link>

    <nuxt-link
      v-for="(tag, index) in tags"
      :key="index"
      :to="(category.slug ?`/${category.slug}` : '/articles') + `?blog-tag=${tag}`"
      class="material-tags__tag"
    >
      #{{ tag }}
    </nuxt-link>

    <p>{{ materialDate }}</p>
  </div>
</template>

<script>
export default {
  name: 'MaterialTags',
  props: {
    material: {
      type: Object,
      required: true,
    },
  },
  computed: {
    category() {
      return this.material.categories?.[0] || { slug: 'articles', name: 'Статьи' };
    },
    getCategoryClass() {
      switch (this.category.name?.toLowerCase()) {
        case 'новости':
          return 'violet';
        case 'родителям':
        case 'лайфстайл':
          return 'green';
        case 'домашняя школа':
        case 'лайфхаки':
        case 'олимпиада':
          return 'orange';
        case 'успеваемость':
        case 'егэ и огэ':
          return 'blue';
        case 'психология':
        case 'навыки':
          return 'pink';
        case 'профессии':
          return 'red';
        default:
          return 'violet';
      }
    },
    tags() {
      return this.material.tags;
    },
    materialDate() {
      return new Date(this.material?.createdAt).toLocaleDateString('ru-RU');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../styles/main.scss';

.material-tags {
  display: flex;
  align-items: center;
  gap: calc(var(--scale) * 4);
  flex-wrap: wrap;

  &__category {
    padding: calc(var(--scale) * 8) calc(var(--scale) * 14) calc(var(--scale) * 10);
    background-color: #5237E6;
    border-radius: calc(var(--scale) * 40);
    transition: 200ms;

    text-transform: lowercase;
    font-weight: 500;
    font-size: calc(var(--scale) * 16);
    line-height: 130%;
    color: #FFFFFF;
    white-space: nowrap;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 6) calc(var(--scale) * 12) calc(var(--scale) * 8);
      font-size: calc(var(--scale) * 14);
    }

    &.violet {
      background-color: #E6CEFF;
      color: #5237E6;

      &:hover {
        background-color: #5237E6;
        color: #ffffff;
      }
    }

    &.green {
      background-color: #D1FAD8;
      color: #01410D;

      &:hover {
        background-color: #01410D;
        color: #ffffff;
      }
    }

    &.orange {
      background-color: #FFF0D1;
      color: #FF5319;

      &:hover {
        background-color: #FF5319;
        color: #ffffff;
      }
    }

    &.blue {
      background-color: #CEF9FF;
      color: #0A4183;

      &:hover {
        background-color: #0A4183;
        color: #ffffff;
      }
    }

    &.pink {
      background-color: #FFCEE2;
      color: #8D176C;

      &:hover {
        background-color: #8D176C;
        color: #ffffff;
      }
    }

    &.red {
      background-color: #FFCDCF;
      color: #8D1717;

      &:hover {
        background-color: #8D1717;
        color: #ffffff;
      }
    }
  }

  &__tag {
    padding: calc(var(--scale) * 7) calc(var(--scale) * 13) calc(var(--scale) * 9);
    background-color: #FFFFFF;
    border: 1px solid #CACACB;
    border-radius: calc(var(--scale) * 40);

    font-family: 'Onest', sans-serif;
    font-weight: 500;
    font-size: calc(var(--scale) * 16);
    line-height: 130%;
    color: #02120F;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 6) calc(var(--scale) * 12) calc(var(--scale) * 8);
      font-size: calc(var(--scale) * 14);
    }
  }

  p {
    margin-left: auto;
    font-weight: 500;
    font-size: calc(var(--scale) * 16);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      font-size: calc(var(--scale) * 12);
    }
  }
}

</style>
